export enum TimeToBuildEnum {
  ASAP = "As soon as possible",
  THREE_MONTHS = "Within 3 months",
  SIX_MONTHS = "3 - 6 months",
  MORE_THAN_SIX_MONTHS = "More than 6 months",
}
